/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-05 12:43:43
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-05 12:49:21
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelLegal/Components/Action/index.tsx
 */
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';
const Action = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { onDelete, onEdit } = props;
  return (
    <div className={css.container}>
      {onDelete && (
        <div className={css.delete} onClick={onDelete}>
          {getI18n('general.delete')}
        </div>
      )}

      <div className={css.edit} onClick={onEdit}>
        {getI18n('general.edit')}
      </div>
    </div>
  );
};
export default Action;
